export default __webpack_public_path__ + "static/media/Asics.c29be3f1.jpeg";